"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
require("./ListTitle.scss");
const ListTitle = (0, react_1.forwardRef)(({ className, id, children, tabIndex }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ "aria-level": 3, tabIndex: tabIndex, role: "heading", ref: mergedRef, className: (0, classnames_1.default)("list-title", className), id: id }, { children: children })));
});
Object.assign(ListTitle, {
    // Used by VirtualizedListItems
    displayName: "ListTitle"
});
exports.default = ListTitle;
